import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = (serviceCompanyId) => ['shutdownCities', serviceCompanyId];

const shutdownCitiesQuery = async (serviceCompanyId) => {
  let url = `/Alert/cities`;

  if (!!serviceCompanyId) url += `?serviceCompanyId=${serviceCompanyId}`;

  return await request.get(url, {}, `При загрузке городов произошла ошибка`);
};

export const useShutdownCities = (serviceCompanyId, options) =>
  useQuery(
    key(serviceCompanyId),
    () => shutdownCitiesQuery(serviceCompanyId),
    options
  );
